var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"black"}},[_c('img',{staticStyle:{"width":"100%","height":"100%","max-width":"100vw","max-height":"100vh","object-fit":"contain"},attrs:{"src":_vm.imageUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }